import { ExperienceType } from '@/generated/graphql';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { ClickAwayListener, Grid, MenuList, Paper, useMediaQuery } from '@mui/material';
import { useSearchParams } from 'next/navigation';
import React from 'react';
import { useExploreQuery } from '../hooks/use-explore-query';
import useSetType from '../hooks/use-set-type';
import ButtonAvatar, { AvatarImage } from './button-avatar';
import StyledButton, {
  StyledButtonGroup,
  StyledGrow,
  StyledMenuItem,
  StyledPopper,
} from './dropdown-button';
const options = [ExperienceType.Schedule, ExperienceType.Event]; //, ExperienceType.Box];
const NewFormatFilterButton = () => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const setType = useSetType();
  const { refetch } = useExploreQuery();
  const searchParams = useSearchParams();
  const type = searchParams?.get('type');
  const isMobile = useMediaQuery('(max-width: 960px');

  const handleMenuItemClick = async (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    if (options[index] === type) {
      setType(undefined);
    } else {
      setType(options[index]);
      setOpen(false);
      await refetch();
    }
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };
  const handleClick = async () => {
    if (type) {
      setType(undefined);
    } else {
      handleToggle();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const checkType = () => {
    if (type) {
      return <CloseIcon style={{ color: 'black' }} />;
    }
    return <KeyboardArrowDown style={{ color: 'black' }} />;
  };
  const checkSelectedType = () => {
    if (type === ExperienceType.Event) {
      return 'Group';
    } else if (type === ExperienceType.Schedule) {
      return 'One-on-One';
    } else if (type === ExperienceType.Box) {
      return 'Box';
    } else {
      return isMobile ? 'Format' : 'Choose by format';
    }
  };
  const selected = type !== undefined && type !== null;

  return (
    <Grid container direction="column" alignItems="center" style={{ width: 'auto' }}>
      <Grid item xs={12}>
        <StyledButtonGroup
          variant="contained"
          ref={anchorRef}
          className={selected ? 'selected' : ''}
        >
          <StyledButton onClick={handleClick}>
            {selected && (
              <ButtonAvatar style={{ marginRight: 10, width: 30, height: 30 }}>
                <AvatarImage src={`/tasks/${type?.toString().toLocaleLowerCase()}/group.png`} />
              </ButtonAvatar>
            )}
            {checkSelectedType()}
            {checkType()}
          </StyledButton>
        </StyledButtonGroup>
        <StyledPopper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps }) => (
            <StyledGrow {...TransitionProps}>
              <Paper style={{ width: 'max-content' }}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" style={{ paddingTop: 12, paddingBottom: 12 }}>
                    {options.map((option, index) => (
                      <StyledMenuItem
                        key={option}
                        selected={selected}
                        onClick={event => handleMenuItemClick(event, index)}
                        divider={index < options.length - 1}
                      >
                        <ButtonAvatar style={{ marginRight: 10, width: 30, height: 30 }}>
                          <AvatarImage src={`/tasks/${option.toLowerCase()}/group.png`} />
                        </ButtonAvatar>
                        {option === ExperienceType.Schedule
                          ? 'One-on-One'
                          : option === ExperienceType.Event
                            ? 'Group'
                            : 'Box'}
                      </StyledMenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </StyledGrow>
          )}
        </StyledPopper>
      </Grid>
    </Grid>
  );
};
export default NewFormatFilterButton;
